import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useProfileSubmissionCheck = (applicantUserData: any, applicantUserId: string) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (applicantUserData?.applicantUser?.isProfileSubmitted) {
      navigate(`/applicant/cases`);
    }
  }, [applicantUserData, applicantUserId, navigate]);
};